angular.module('impactx.supplierbasket').controller('SupplierBasketInformationTextCtrl', [
    'informationText',
    'themeFactory',
    'TranslationService',
    '$mdDialog',
    '$sce',
    SupplierBasketInformationTextCtrl]);

function SupplierBasketInformationTextCtrl(informationText, themeFactory, TranslationService, $mdDialog, $sce) {
    var self = this;
    self.theme = themeFactory.getTheme();
    self.informationText = informationText;
    self.abort = TranslationService.get('abort');
    self.sce = $sce;

    self.cancel = function() {
        $mdDialog.cancel();
    };
}